// -------------------------------------------
// JavaScript Google Map
// Author: Globalia
// Licensed under the WTFPL license
// -------------------------------------------
// ...

( function( global ) { // eslint-disable-line

    var pluginName = 'grGoogleMap';

    var loadAPI = function loadAPI(options, callback, callbackAPI) {
        // Load Youtube API
        var tag  = document.createElement('script'),
            head = document.getElementsByTagName('head')[0];

        if (window.location.origin == 'file://') {
            tag.src = 'https://maps.googleapis.com/maps/api/js?key=' + options.api_key + '&callback=googleMapsInitiated';
        } else {
            tag.src = '//maps.googleapis.com/maps/api/js?key=' + options.api_key + '&callback=googleMapsInitiated';
        }

        tag.async = true;
        head.appendChild(tag);

        // Clean up Tags.
        head = null;
        tag = null;

        apiIsReady(callback, callbackAPI);
    };

    var apiIsReady = function apiIsReady(callback, callbackAPI) {
        // Listen for Gobal YT player callback
        if (typeof window.google === 'undefined' && typeof window.loadingMap === 'undefined') {
            // Prevents Ready Event from being called twice
            window.loadingMap = true;

            // Creates deferred so, other players know when to wait.
            window.dfd_gm = $.Deferred();

            window.googleMapsInitiated = function() {
                Object.keys(callbackAPI).forEach(function(key) {
                    callbackAPI[key]();
                });

                window.googleMapsInitiated = null;
                window.dfd_gm.resolve("done");
                callback();
            };
        } else if (typeof window.google === 'object' && window.google, maps) {
            callback();
        } else {
            window.dfd_gm.done(function(name) {
                callback();
            });
        }
    };

    // Constructor

    function grGoogleMap(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Set default parameters
        this.options = {
            api_key: 'AIzaSyBizm1GWW3neDpQw0P3HU7dN9DouGIDN-A',
            lat: 45.502831,
            lng: -73.513693,
            url: 'https://goo.gl/maps/kFc2hjWsvAP2',
            inactive_pin: '/dist/img/map/inactif.png',
            active_pin: '/dist/img/map/actif.png',
            title: '',
            mapType: 'roadmap',
            markers: [],
            map_options: {
                zoom: 15,
                styles: window.googleMapStyleArray,
                center: {},
                scrollwheel: false,
                disableDoubleClickZoom: true
            },
            infoWindow: null,
            events: null
        };

        this.lat_lng = {};

        this.map = {};
        this.bounds = {};

        this.onReady = function() {};

        this.callbackAPI = {};

        // Retrieve plugin custom parameters
        this.param = this.selector.getAttribute('gr-google-map').split(' ');

        // Overwrite with custom parameters
        for (var i = 0, len = this.param.length; i < len; i++) {
            var attr = this.param[i];

            if (isNaN(attr)) {
                this.callbackAPI[attr] = window[attr];
            } else {
                if (this.lat_lng.lat === undefined) {
                    this.lat_lng.lat = parseFloat(attr);
                } else if (this.lat_lng.lng === undefined) {
                    this.lat_lng.lng = parseFloat(attr);
                }
            }
        }

        this.options.map_options.center = this.lat_lng;

        this.init();
    }

    // Methods

    grGoogleMap.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            var self = this;

            // Bind all event handlers for referencability
            var arrHandler = ['resizeHandler'];
            for (var i = 0, len = arrHandler.length; i < len; i++) {
                var method = arrHandler[i];
                this[method] = this[method].bind(this);
            }

            window.addEventListener('resize', this.resizeHandler);

            loadAPI(self.options, self.googleMapsInitiated.bind(self), self.callbackAPI);

            // Flag the plugin as ready
            self.ready = true;
            global.methods.toggleAttributeValue(self.selector, 'gr-google-map', 'ready');
            if (groots.verbose) console.log(pluginName + ': ready');
        }
    };

    grGoogleMap.prototype.createMarker = function createMarker(options) {
        var self = this;

        if (options.lat == undefined && options.lng == undefined && options.position == undefined) {
            throw 'No latitude or longitude defined.';
        }

        var details = options.details,
            base_options = {
                position: new google.maps.LatLng(options.lat, options.lng),
                map: self.map,
                icon: self.options.inactive_pin
            },
            marker_options = {};

        global.methods.objectAssign(base_options, options);
        global.methods.objectAssign(marker_options, base_options);

        var marker = new google.maps.Marker(marker_options);

        if (options.infoWindow) marker.infoWindow = new google.maps.InfoWindow(options.infoWindow);

        google.maps.event.addListener(marker, 'click', function() {
            this.details = details;

            self.map.panTo(this.getPosition());

            for (var i = 0, marker; marker = self.options.markers[i]; i++) {
                marker.setIcon(self.options.inactive_pin);
            }

            this.setIcon(self.options.active_pin);

            if (options.click) options.click.apply(this, [this]);

            if (options.infoWindow) {
                for (var i = 0, marker; marker = self.options.markers[i]; i++) {
                    if (marker.infoWindow) marker.infoWindow.close();
                }

                this.infoWindow.open(self.map, this);
            }
        });

        return marker;
    };

    grGoogleMap.prototype.addMarker = function addMarker(options) {
        var self = this;
        var marker;

        if (options.hasOwnProperty('gm_accessors_')) {
            // Native google.maps.Marker object
            marker = options;
        } else {
            if ((options.hasOwnProperty('lat') && options.hasOwnProperty('lng')) || options.position) {
                marker = self.createMarker(options);
                //this.bounds.extend(new window.google.maps.LatLng(options.lat, options.lng));
            } else {
                throw 'No latitude or longitude defined.';
            }
        }

        self.options.markers.push(marker);
        //self.onDone();

        return marker;
    };

    grGoogleMap.prototype.addMarkers = function addMarkers(array) {
        for (var i = 0, marker; marker = array[i]; i++) {
            this.addMarker(marker);
        }

        return this.markers;
    };

    grGoogleMap.prototype.googleMapsInitiated = function googleMapsInitiated() {
        var self = this;
        global.methods.toggleAttributeValue(self.selector, 'gr-google-map', 'processing');

        self.map = new google.maps.Map(self.selector, {
            zoom: 13,
            styles: window.styleArray,
            scrollwheel: false,
            disableDoubleClickZoom: true
        });

        self.map.setOptions(self.options.map_options);
        //self.bounds = new window.google.maps.LatLngBounds();

        self.onReady();
    };

    grGoogleMap.prototype.resizeHandler = function resizeHandler() {
        var self = this;
        global.methods.toggleAttributeValue(self.selector, 'gr-google-map', 'processing');
        self.onDone();
    };

    grGoogleMap.prototype.onDone = function onDone() {
        var self = this;

        if (self.options.markers.length > 1) {
            self.map.fitBounds(self.bounds);
        } else if (self.options.markers.length == 1) {
            var center = self.map.getCenter();
            google.maps.event.trigger(self.map, "resize");
            self.map.setCenter(center);
        }

        global.methods.removeAttributeValue(self.selector, 'gr-google-map', 'processing');
        global.methods.toggleAttributeValue(self.selector, 'gr-google-map', 'done');
    };

    // Auto-Instantiation

    var all = {}, index;
    window.addEventListener('load', function() {
        if (document.querySelectorAll('[gr-google-map]').length) {
            window.groots.grGoogleMap = {instances: {}};
            all = document.querySelectorAll('[gr-google-map]');
            index = -1;
            while (all[++index])
                global.grGoogleMap.instances[index] = new grGoogleMap(all[index]);
        }
    }, false);

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports)
        module.exports = grGoogleMap;
    // Export to Browser
    else
        global[pluginName] = grGoogleMap; // eslint-disable-line

}(window.groots));
